class ShowMoreCollection extends HTMLElement {
  constructor() {
    super();
    this.currentPage = 1;
    this.btn = this.querySelector('.show-more-collection-trigger');
    this.btn.addEventListener('click', this.onBtnClinck);
    this.wrapper = document.querySelector('[data-product-grid]');
    this.itemsPerRow = {
      desktop: Number(this.getAttribute('data-desktop-per-row')) || 3,
      mobile: Number(this.getAttribute('data-mobile-per-row')) || 2,
    };
    this.checkItemsVisibility();
  }

  onBtnClinck = async (e) => {
    const el = e.currentTarget;
    el.classList.add('btn--loading');
    el.disabled = true;
    this.wrapper = document.querySelector('[data-product-grid]');
    if (!this.wrapper) {
      el.classList.remove('btn--loading');
      el.disabled = false;
      return;
    }
    const { is_next_page, items } = await this.getNextPage();
    if (!items) {
      el.classList.remove('btn--loading');
      el.disabled = false;
      return;
    }

    items.forEach((item) => {
      this.wrapper.appendChild(this.initProductItem(item));
    });
    if (window.AOS) {
      AOS.init();
    }

    el.classList.remove('btn--loading');
    el.disabled = false;

    if (!is_next_page) {
      el.classList.add('show-more-collection-trigger-hidden');
    }

    this.checkItemsVisibility({ newItems: items, is_next_page: is_next_page });
  };

  checkItemsVisibility = ({ is_next_page = true } = {}) => {
    this.wrapper = document.querySelector('[data-product-grid]');
    const items = [...this.wrapper.querySelectorAll('.grid-product')];
    const isPromoImages = items.some((item) =>
      item.classList.contains('grid__item-promo'),
    );
    items.forEach((item) => item.classList.remove('hide'));
    if (is_next_page && isPromoImages) {
      const itemsPerRow =
        document.body.offsetWidth > 765
          ? this.itemsPerRow.desktop
          : this.itemsPerRow.mobile;
      const remainingAmount = items.length % itemsPerRow;
      items
        .reverse()
        .slice(0, remainingAmount)
        .forEach((item) => item.classList.add('hide'));
    }
  };

  initProductItem = (el) => {
    el.querySelectorAll('.quick-product__btn').forEach((quickProductBtn) => {
      quickProductBtn.classList.remove('btn--not-ready');
    });
    theme.preloadProductModal(
      el.getAttribute('data-product-handle'),
      el.getAttribute('data-product-id'),
      null,
    );
    return el;
  };

  getNextPage = async () => {
    try {
      let url = location.pathname;
      if (location.search.length) {
        const cleanedSearch = location.search
          .replace(/([?&])page=\d+(&)?/, (match, p1, p2) => {
            if (p1 === '?' && p2) return '?';
            if (p1 === '&' && p2) return '&';
            return '';
          })
          .replace(/&$/, ''); // clean trailing &
        url += `${cleanedSearch}&page=${this.currentPage + 1}`;
      } else {
        url += `?page=${this.currentPage + 1}`;
      }
      const rawHtml = await fetch(url).then((res) => res.text());
      if (!rawHtml) {
        return null;
      }
      const html = this.parseHTML(rawHtml);
      if (!html) {
        return null;
      }
      this.currentPage += 1;
      const isNextPage = html.querySelector('show-more-collection') !== null;
      return {
        is_next_page: isNextPage,
        items: [...html.querySelectorAll('.grid-product')],
      };
    } catch (e) {
      console.error(e);
      return {
        is_next_page: true,
        items: null,
      };
    }
  };

  parseHTML = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    return doc.body;
  };
}

if (!customElements.get('show-more-collection')) {
  customElements.define('show-more-collection', ShowMoreCollection);
}
